import useSWR from 'swr';
import { fetcher } from '../../../../../services/fetcher';
import { AssignCover_API } from "../../../../../api/endpoints";
import DataTable from "../../../../../common/components/DataTable/DataTable";

const EmployeeAssignCover = () => {

  const { data, error, isLoading } = useSWR(AssignCover_API, fetcher);

  const tableConfig = {
    fields: [
      { key: "title", label: "Name" },
      { key: "cover_scope", label: "Scope" },
      { key: "currency", label: "Currency" },
      { key: "price", label: "Price" },
    ],
    selectionCheckbox: true,
    scrollable: true,
    
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading assignment plan</div>;

  const assignedCovers = Array.isArray(data.customize_covers)
    ? data.customize_covers
    : [];

  return (
    <>
      <DataTable
        config={tableConfig}
        data={assignedCovers}
        heading={"Assigned Covers"}
      />
    </>
  );
};

export default EmployeeAssignCover;